import { calendar_v3 } from "googleapis";

export function isEventBeforeToday(event: calendar_v3.Schema$Event) {
  const startDateString = event.start?.dateTime ?? event.start?.date ?? "";
  if (!startDateString) {
    return false;
  }

  const eventDate = new Date(startDateString);
  return eventDate < new Date();
}
